import { useContext } from 'react'
import { SignedInStatusContext } from '@/context/SignedInStatusContext'

export default function useClientSideSignedInData() {
  const clientSideSignedInData = useContext(SignedInStatusContext)
  if (!clientSideSignedInData) {
    return {
      signedIn: false,
      firstName: undefined,
      email: undefined
    } as const
  }
  return {
    signedIn: true,
    ...clientSideSignedInData
  } as const
}
